export const PROJECT_NAME = 'Abo Eltalabat';
export const PROJECT_NAMES = 'لوحة تحكم أبو الطلبات';
export const BASE_URL = 'https://dash.aboeltalabat.online'; //https://back-api.aboeltalabat.com

   //http://127.0.0.1:8000,https://back-api.aboeltalabat.com, process.env.REACT_APP_BASE_URL

export const WEBSITE_URL = 'https://AboEltalabat.com';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = BASE_URL + '/storage/';
export const MAP_API_KEY = 'AIzaSyAIZAHqq0Gpw0yNcq6LgsQd9EAGpee5sMg';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';

export const VAPID_KEY =
  '';

export const LAT =0;
export const LNG = 0;

export const API_KEY = '';
export const AUTH_DOMAIN = '';
export const PROJECT_ID = '';
export const STORAGE_BUCKET = '';
export const MESSAGING_SENDER_ID = '';
export const APP_ID = '';
export const MEASUREMENT_ID = '';

export const RECAPTCHASITEKEY = '';

// export const DEMO_SELLER = ; // seller_id
// export const DEMO_SELLER_UUID = '3566bdf6-3a09---'; // seller_id
// export const DEMO_SHOP = 599; // seller_id
// export const DEMO_DELIVERYMAN = 375; // deliveryman_id
// export const DEMO_MANEGER = 114; // deliveryman_id
// export const DEMO_MODERATOR = 297; // deliveryman_id
// export const DEMO_ADMIN = 107; // deliveryman_id

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/svg',
];
